import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Unregister all service workers
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}

(async () => {
  try {
    const res = await fetch("/version.json", { cache: "no-store" });
    const version = await res.text();
    const previous = localStorage.getItem("app_version");
    if (version !== previous) {
      localStorage.setItem("app_version", version);
      window.location.reload();
    }
  } catch (err) {
    console.warn("Version check failed:", err);
  }
})();

